import * as React from 'react';
import { Box, Grid, Button, TextField, Paper, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Snackbar, Alert } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FormHelperText from '@mui/material/FormHelperText';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Modal from '@mui/material/Modal';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: window.innerWidth < 767 ? '80%' : '70%',
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export const AssignedComp = (props) => {



    return (
        <Box>
            <Modal
                open={true}
                onClose={() => props.ToggleFilterBox()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box p={1}>
                        <Typography className='grey-theme-btn' variant="h6" component="h2">
                            Assign Leads
                        </Typography>
                    </Box>

                    <Grid container>

                        <Grid xs={12} md={4}>
                            <Box p={1}>
                                <FormControl fullWidth>
                                    <TextField
                                        select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={props.AssignFormData.ddlAssignOperation || ''}
                                        label="Select Operation"
                                        multiple={false}
                                        error={props.AssignFormData.ddlAssignOperationErr == undefined || props.AssignFormData.ddlAssignOperationErr == '' ? false : true}
                                        onChange={(e) => props.HandleInputs(e, 'ddlAssignOperation')}
                                    >
                                        <MenuItem value={'Assign'}>{'Assign'}</MenuItem>
                                        <MenuItem value={'Re-Assign'}>{'Re-Assign'}</MenuItem>
                                        <MenuItem value={'Remove'}>{'Remove'}</MenuItem>
                                    </TextField>
                                    <FormHelperText style={{ color: 'red' }}>{props.AssignFormData.ddlAssignOperationErr}</FormHelperText>
                                </FormControl>
                            </Box>
                        </Grid>

                        <Grid xs={12} md={4}></Grid>
                        <Grid xs={12} md={4}></Grid>

                        {
                            props.AssignFormData.ddlAssignOperation !== undefined && props.AssignFormData.ddlAssignOperation !== '' ?
                                <Grid xs={12} md={4}>
                                    <Box p={1}>
                                        <FormControl fullWidth>
                                            <TextField
                                                select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={props.AssignFormData.ddlAssignDateRange || ''}
                                                label="Date Type"
                                                multiple={false}
                                                error={props.AssignFormData.ddlAssignDateRangeErr == undefined || props.AssignFormData.ddlAssignDateRangeErr == '' ? false : true}
                                                onChange={(e) => props.HandleInputs(e, 'ddlAssignDateRange')}
                                            >
                                                <MenuItem value={'Date Range'}>{'Date Range'}</MenuItem>
                                                <MenuItem value={'All'}>{'All'}</MenuItem>
                                            </TextField>
                                            <FormHelperText style={{ color: 'red' }}>{props.AssignFormData.ddlAssignDateRangeErr}</FormHelperText>
                                        </FormControl>
                                    </Box>
                                </Grid>
                                :
                                ''
                        }




                        {
                            props.AssignFormData.ddlAssignDateRange === 'Date Range' ?
                                <Grid xs={12} md={4}>
                                    <Box pl={1} pr={1}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={['DatePicker']}>
                                                <DatePicker sx={{ width: '100%' }} onChange={(e) => props.HandleInputs(e, 'txtLeadAssignStartDate')} label="Start Date"
                                                    value={props.AssignFormData.txtLeadAssignStartDate !== '' ? dayjs(props.AssignFormData.txtLeadAssignStartDate) : null}
                                                />
                                            </DemoContainer>
                                            <FormHelperText style={{ color: 'red' }}>{props.AssignFormData.txtLeadAssignStartDateErr}</FormHelperText>
                                        </LocalizationProvider>
                                    </Box>
                                </Grid>
                                :
                                ''
                        }
                        {
                            props.AssignFormData.ddlAssignDateRange === 'Date Range' ?
                                <Grid xs={12} md={4}>
                                    <Box pl={1} pr={1}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={['DatePicker']}>
                                                <DatePicker sx={{ width: '100%' }} onChange={(e) => props.HandleInputs(e, 'txtLeadAssignEndDate')} label="End Date"
                                                    value={props.AssignFormData.txtLeadAssignEndDate !== '' ? dayjs(props.AssignFormData.txtLeadAssignEndDate) : null}
                                                //value={dayjs(props.AssignFormData.txtLeadAssignEndDate != undefined ? props.AssignFormData.txtLeadAssignEndDate : '')}
                                                />
                                            </DemoContainer>
                                             <FormHelperText style={{ color: 'red' }}>{props.AssignFormData.txtLeadAssignEndDateErr}</FormHelperText>
                                        </LocalizationProvider>
                                    </Box>
                                </Grid>

                                :
                                ''
                        }



                        {props.AssignFormData.ddlAssignOperation !== undefined && props.AssignFormData.ddlAssignOperation !== '' ?
                            <Grid xs={12} md={4}>
                                <Box p={1}>
                                    <FormControl fullWidth>
                                        <TextField
                                            select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={props.AssignFormData.ddlLeadAssignDep || ''}
                                            label="Select Department"
                                            error={props.AssignFormData.ddlLeadAssignDepErr == undefined || props.AssignFormData.ddlLeadAssignDepErr == '' ? false : true}
                                            onChange={(e) => props.HandleInputs(e, 'ddlLeadAssignDep')}
                                        >
                                            {
                                                props.mystate.profileListData.length > 0 ?
                                                    props.mystate.profileListData.map((item) =>
                                                        item.profile_name.includes('Sales') ?
                                                            <MenuItem value={item.profile_name}>{item.profile_name}</MenuItem>
                                                            :
                                                            null
                                                    )
                                                    :
                                                    null
                                            }
                                        </TextField>
                                        <FormHelperText style={{ color: 'red' }}>{props.AssignFormData.ddlLeadAssignDepErr}</FormHelperText>
                                    </FormControl>
                                </Box>
                            </Grid>
                            :
                            ''}

                        {props.AssignFormData.ddlAssignOperation !== undefined && props.AssignFormData.ddlAssignOperation !== '' ?

                            <Grid xs={12} md={4}>
                                <Box p={1}>
                                    <FormControl fullWidth>
                                         <InputLabel id="demo-simple-select-label">Select Owner</InputLabel>
                                        <Select
                                            select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={props.AssignFormData.ddlLeadAssignOwner || []}
                                            label="Select Owner"
                                            multiple={true}
                                            error={props.AssignFormData.ddlLeadAssignOwnerErr == undefined || props.AssignFormData.ddlLeadAssignOwnerErr == '' ? false : true}
                                            onChange={(e) => props.HandleInputs(e, 'ddlLeadAssignOwner')}
                                        >
                                            {
                                                props.mystate.userListData.length > 0 ?

                                                    props.mystate.userListData.map((item) =>
                                                        item.user_profile_name === props.AssignFormData.ddlLeadAssignDep ?
                                                            <MenuItem value={item.user_name}>{item.user_name}</MenuItem>
                                                            :
                                                            null
                                                    )
                                                    :
                                                    null
                                            }
                                        </Select>
                                        <FormHelperText style={{ color: 'red' }}>{props.AssignFormData.ddlLeadAssignOwnerErr}</FormHelperText>
                                    </FormControl>
                                </Box>
                            </Grid>
                            :
                            ''
                        }

                    </Grid>

                    {
                        props.mystate.totalLeads !== '' ?
                            <Grid container>
                                <Grid xs={12} md={12}>
                                    <Box p={1}>
                                        <Typography className='grey-theme-btn' variant="h6" component="h6">
                                            Total Leads Found
                                        </Typography>
                                        <Typography className='grey-theme-btn' variant="p" component="p">
                                            {props.mystate.totalLeads}
                                        </Typography>
                                    </Box>
                                </Grid>
                                {
                                    props.AssignFormData.ddlAssignOperation === 'Assign' ?
                                        <Grid xs={12} md={4}>
                                            <Box p={1}>
                                                <TextField className="text-input" id="txtAssignedLeadsNumber" name='txtAssignedLeadsNumber' error={props.AssignFormData.txtAssignedLeadsNumberErr == undefined || props.AssignFormData.txtAssignedLeadsNumberErr == '' ? false : true} helperText={props.AssignFormData.txtAssignedLeadsNumberErr} onChange={(e) => props.HandleInputs(e, 'txtAssignedLeadsNumber')} value={props.AssignFormData.txtAssignedLeadsNumber || ''} label="Number of Leads*" inputProps={{ maxLength: 10 }} variant="outlined" />
                                            </Box>
                                        </Grid>
                                        :
                                        ''
                                }

                                {
                                    props.AssignFormData.ddlAssignOperation === 'Re-Assign' ?
                                        <Grid xs={12} md={4}>
                                            <Box p={1}>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        value={props.AssignFormData.ddlLeadReAssignDep || ''}
                                                        label="Select Department"
                                                        error={props.AssignFormData.ddlLeadReAssignDepErr == undefined || props.AssignFormData.ddlLeadReAssignDepErr == '' ? false : true}
                                                        onChange={(e) => props.HandleInputs(e, 'ddlLeadReAssignDep')}
                                                    >
                                                        {
                                                            props.mystate.profileListData.length > 0 ?
                                                                props.mystate.profileListData.map((item) =>
                                                                    item.profile_name.includes('Sales') ?
                                                                        <MenuItem value={item.profile_name}>{item.profile_name}</MenuItem>
                                                                        :
                                                                        null
                                                                )
                                                                :
                                                                null
                                                        }
                                                    </TextField>
                                                    <FormHelperText style={{ color: 'red' }}>{props.AssignFormData.ddlLeadReAssignDepErr}</FormHelperText>
                                                </FormControl>
                                            </Box>
                                        </Grid>

                                        : ''}
                                {
                                    props.AssignFormData.ddlAssignOperation === 'Re-Assign' ?
                                        <Grid xs={12} md={4}>
                                            <Box p={1}>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        value={props.AssignFormData.ddlLeadReAssignOwner || ''}
                                                        label="Select Owner"
                                                        multiple={false}
                                                        error={props.AssignFormData.ddlLeadReAssignOwnerErr == undefined || props.AssignFormData.ddlLeadReAssignOwnerErr == '' ? false : true}
                                                        onChange={(e) => props.HandleInputs(e, 'ddlLeadReAssignOwner')}
                                                    >
                                                        {
                                                            props.mystate.userListData.length > 0 ?

                                                                props.mystate.userListData.map((item) =>
                                                                    item.user_profile_name === props.AssignFormData.ddlLeadReAssignDep ?
                                                                        <MenuItem value={item.user_name}>{item.user_name}</MenuItem>
                                                                        :
                                                                        null
                                                                )
                                                                :
                                                                null
                                                        }
                                                    </TextField>
                                                    <FormHelperText style={{ color: 'red' }}>{props.AssignFormData.ddlLeadReAssignOwnerErr}</FormHelperText>
                                                </FormControl>
                                            </Box>
                                        </Grid>
                                        : ''}
                            </Grid>
                            :
                            ''
                    }

                    {
                        props.mystate.totalLeads !== '' ?

                            <Box mt={2} p={1}>
                                <Grid container>
                                    <Grid sx={6}>
                                        <Button className='grey-theme-btn' variant="outlined" onClick={() => props.AssignLeads()}>{props.AssignFormData.ddlAssignOperation === 'Remove' ? 'Remove Leads' : props.AssignFormData.ddlAssignOperation === 'Re-Assign' ? 'Re-Assign Leads' : 'Assign Leads'}</Button>
                                    </Grid>
                                    <Grid sx={6} ml={2}>
                                        <Button className='grey-theme-btn' variant="outlined" onClick={() => props.ToggleFilterBox()}>Cancel</Button>
                                    </Grid>
                                </Grid>
                            </Box>
                            :

                            <Box mt={2} p={1}>
                                <Grid container>
                                    <Grid sx={6}>
                                        <Button className='grey-theme-btn' variant="outlined" onClick={() => props.SearchLeadsForAssign()}>Get Leads</Button>
                                    </Grid>
                                    <Grid sx={6} ml={2}>
                                        <Button className='grey-theme-btn' variant="outlined" onClick={() => props.ToggleFilterBox()}>Cancel</Button>
                                    </Grid>
                                </Grid>
                            </Box>
                    }
                </Box>
            </Modal>

            <Snackbar open={props.mystate.showAlert} autoHideDuration={3000} onClose={() => { props.HandleCloseAlertMsg(props.mystate.alertType) }}>
                <Alert
                    onClose={() => { props.HandleCloseAlertMsg(props.mystate.alertType) }}
                    severity={props.mystate.alertType}
                    variant="filled"
                    sx={{ width: '100%' }}

                >
                    {props.mystate.alertMsg}
                </Alert>
            </Snackbar>

        </Box>


    );
}